import * as React from "react";
import { withFormik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input/input";
import Button from "../../components/button/button";
import {
  ContactWrapper,
  ContactPageTitle,
  ContactFromWrapper,
  InputGroup,
} from "./style";

interface MyFormValues {
  firstName: string;
  email: string;
  message: string;
}

const SignupSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  message: Yup.string().required("Required"),
});

const Contact: React.SFC<{}> = () => {
  const formEl = React.useRef(null);

  const doHtmlFormPost = () => {
    formEl.current.submit();
  };

  const MyForm = withFormik({
    handleSubmit: doHtmlFormPost,
    validationSchema: SignupSchema,
    mapPropsToValues: () => ({
      firstName: "",
      email: "",
      message: "",
    }),
  })((props) => {
    const {
      handleBlur,
      handleChange,
      handleSubmit,
      touched,
      values,
      errors,
      isSubmitting,
    } = props;

    return (
      <form
        method="post"
        action="https://www.flexyform.com/f/eb7515bb0490ca48300af0d8c0ed66b80f16c796"
        ref={formEl}
        onSubmit={handleSubmit}
      >
        <ContactWrapper>
          <ContactPageTitle>
            <h2>Contact</h2>
            <p>You can drop a message here</p>
          </ContactPageTitle>
          <ContactFromWrapper>
            <InputGroup>
              <Input
                type="text"
                name="firstName"
                value={`${values.firstName}`}
                onChange={handleChange}
                onBlur={handleBlur}
                label="First Name"
                notification={`${
                  errors.firstName && touched.firstName ? errors.firstName : ""
                }`}
              />
              <Input
                type="email"
                name="email"
                value={`${values.email}`}
                onChange={handleChange}
                onBlur={handleBlur}
                label="Email"
                notification={`${
                  errors.email && touched.email ? errors.email : ""
                }`}
              />
            </InputGroup>
            <Input
              type="textarea"
              name="message"
              value={`${values.message}`}
              onChange={handleChange}
              onBlur={handleBlur}
              label="Message"
              notification={
                errors.message && touched.message ? errors.message : ""
              }
            />
            <Button
              title="Submit"
              type="submit"
              isLoading={isSubmitting ? true : false}
              loader="Submitting.."
            />
          </ContactFromWrapper>
        </ContactWrapper>
        {/* <button type="submit">Submit</button> */}
      </form>
    );
  });

  return <MyForm />;
};

export default Contact;
